import type { ReactNode } from "react";

import { cn } from "@utils";

// A white card over the map, for a slide or for the carousel's loading and empty states
export const HaNSliderCard = ({ className, children }: { className?: string; children: ReactNode }) => {
  return (
    <div className={cn("grid min-h-[100px] w-[312px] rounded-lg bg-white p-2 shadow-mapiq-base", className)}>
      {children}
    </div>
  );
};
